<template>
  <v-container>
    <section class="mt-2 mb-10">
      <!-- 대출 실행 단계에 따른 제목 -->
      <!-- 송금 대기중 -->
      <template v-if="isExecuting">
        <h1 v-if="me" class="font-size--24">
          {{ me.name }} 사장님!<br />
          모집된 대출금을 송금하기 위해 준비 중이에요!
        </h1>
        <ul class="font-size--13 pl-2 ml-n1 outer">
          <li>모집된 대출금의 입금 계좌는 선정산 입금 계좌와 동일합니다.</li>
        </ul>
      </template>

      <!-- 모집중 -->
      <template v-else-if="!isInvestComplete">
        <h1 class="mb-5 mt-5 font-size--26">대출금을 모으고 있어요!</h1>
        <ul class="font-size--14 pl-2 ml-n1 outer">
          <li>펀다에이아이 대출은 P2P 방식으로 온라인 모집하여 지급합니다.</li>
          <li>
            모집 기간은 5일이며, 5일이 경과하기 전에도 모집 중인 일부 금액만으로 지급 신청하실 수
            있습니다.
          </li>
          <li>모집 기간 종료일 오후 4시까지 계약서 작성을 하지 않는 경우는 자동 취소됩니다.</li>
          <li>
            모집 기간이 완료되었어도 전액 모집에 실패한 경우, 신청하신 금액 중 일부만 지급될 수
            있습니다.
          </li>
        </ul>
      </template>

      <!-- 모집 완료 -->
      <template v-else>
        <h1 v-if="me" class="font-size--24">
          {{ me.name }} 사장님,<br />
          투자 모집이 종료되었습니다.
        </h1>
      </template>
    </section>

    <!-- 모집 현황 -->
    <section class="mb-10">
      <v-layout justify-center>
        <v-progress-circular
          :value="investingPercent"
          width="10"
          color="primary"
          size="240"
          rotate="-90"
        >
          <div class="black--text text-center">
            <p class="color--nice-grey mb-1">{{ statusMent }}</p>
            <h1 class="font-size--24 mb-1">{{ commaFormat(investingAmount) }} 원</h1>
            <p v-if="loan">/{{ commaFormat(loan.offer.amount) }} 원</p>
          </div>
        </v-progress-circular>
      </v-layout>
    </section>

    <!-- 계약서 작성 버튼 -->
    <section>
      <BasicButton
        depressed
        height="48"
        :loading="isLoading"
        :disabled="isLoading || (!isInvestComplete && !isInvestMore10) || contractDisabled"
        @click="toContract"
      >
        <!-- 이미 계약서 작성한 경우 -->
        <template v-if="isExecuting">대출금 송금 준비 중</template>
        <!-- 모집 완료 -->
        <template v-else-if="isInvestComplete"> 클릭하여 계약서 작성하기 </template>
        <template v-else-if="isInvestMore10"> 모집 그만하고 지급 신청하기 </template>

        <template v-else> 최소 10만원 이상일 때 신청 가능합니다 </template>
      </BasicButton>
    </section>

    <MarketingStoreBanner class="mt-12" :show-jangsabot="false" />

    <v-footer fixed>
      <v-layout justify-center>
        <v-btn text color="grey" height="25" style="text-decoration: underline" :to="'/'">
          돌아가기
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { commaFormat } from '@/filter/number'

export default {
  components: {
    BasicButton: () => import('@/components/common/button/BasicButton.vue'),
    MarketingStoreBanner: () => import('@/components/marketing/MarketingStoreBanner.vue'),
  },
  data() {
    return {
      investingAmount: 0,
      loan: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapState('contract', { contractCurrent: 'current' }),

    /**
     * 대출 상태
     * 모집중 / 모집 완료 여부
     */
    statusMent() {
      let ment = ''

      if (this.isInvestComplete) {
        ment = '모집 종료'
      } else {
        ment = '모집중입니다'
      }

      return ment
    },

    isInvestComplete() {
      if (!this.loan || !this.investingAmount) return false

      console.log(
        '***** this.loan.status ',
        this.loan.status,
        this.investingAmount,
        this.loan.offer.amount,
        this.isContractTime,
      )

      // 모집 완료
      // 투자완료 상태 or 금액이 다 모집됨 or 작성 시간대 도달
      const completeStatus = this.loan.status === 'invested'

      return (
        (this.isContractTime ||
          completeStatus ||
          this.investingAmount === this.loan.offer.amount) &&
        this.investingAmount > 0
      )
    },

    isInvestMore10() {
      if (!this.loan || !this.investingAmount) return false

      return this.investingAmount >= 100000 // 최소 10만원
    },

    /**
     * 대출 상태
     * 송금대기중
     */
    isExecuting() {
      return this.loan?.status === 'executing'
    },

    /**
     * 계약서 작성 가능 시간대 여부
     */
    isContractTime() {
      if (!this.loan) return false

      const now = this.$moment()
      const start = this.$moment(this.loan.contractStartTime)
      const end = this.$moment(this.loan.contractEndTime)

      return now.isSameOrAfter(start) && now.isBefore(end)
    },

    /**
     * 계약서 작성 버튼 비활성화 여부
     * 폐업 || 작성 가능 시간 아닌 경우 || 송금대기중
     */
    contractDisabled() {
      if (!this.me || !this.loan || !this.investingAmount) {
        console.log('contractDisabled', true)
        return true
      }

      //console.log('contractDisabled2', this.me.store.isClosed, !this.isContractTime, this.isExecuting);

      return this.me.store.isClosed || this.isExecuting
    },

    /**
     * 모집 몇 퍼센트 완료됐는지
     */
    investingPercent() {
      if (!this.loan || !this.investingAmount) return 0
      return ((this.investingAmount / this.loan.offer.amount) * 100).toFixed(0)
    },
  },
  async created() {
    const uuid = this.$route.params.uuid
    const [loan, investingAmount] = await Promise.all([
      this.getLoansDetail(uuid),
      this.getInvestingAmount(uuid),
    ])

    this.loan = loan

    /////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    // test용 숫자!!
    /////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    /////////////////////////////////////
    //this.investingAmount = 100000;

    this.investingAmount = investingAmount || 0
  },
  methods: {
    commaFormat,
    ...mapActions('loan', [
      'getLoansDetail',
      'getInvestingAmount',
      'closeLoan',
      'getLoansByOngoing',
    ]),

    /**
     * 계약서 작성하러 가기
     */
    async toContract() {
      if (this.isLoading) return

      // contract.status가 개시인 경우만 계약서 작성 가능하게 한다.
      if (this.contractCurrent?.status !== 'started') {
        await this.$swal.basic.error({
          text: '고객님은 아직 계약서 작성이 불가능한 상태입니다. 펀다에이아이에 고객 상태 변경을 요청해 주세요.',
        })
        return
      }

      // 모집 중이고 10만원 이상 모였을 때 custom 다이얼로그 표시
      if (!this.isInvestComplete && this.isInvestMore10) {
        const { isConfirmed } = await this.$swal.basic.custom({
          confirmButtonText: '확인',
          showCancelButton: true,
          cancelButtonText: '취소',
          customClass: {
            container: 'custom-alert__container',
            popup: 'custom-alert__popup',
            content: 'custom-alert__content',
            confirmButton: 'custom-alert__ok-btn btn__use-coupon',
            cancelButton: 'custom-alert__cancel-btn',
            actions: 'custom-alert__actions',
          },
          allowOutsideClick: true,
          html: `
            <span style="font-size: 22px; font-weight: 900">투자 모집 종료</span>
            <br /><br />
            <span style="font-size: 14px; vertical-align: middle;">
              투자 모집이 종료되고<br />
              현재 모집액만으로 대출이 실행됩니다.
            </span>
          `,
        })

        if (!isConfirmed) {
          return
        }
      }

      this.isLoading = true
      try {
        // 모집 마감 시킨 후 이동
        await this.closeLoan(this.loan.uuid)
        // 대출 상태 업데이트
        await this.getLoansByOngoing()
        await this.$router.push({
          name: 'loan/contract',
          params: { uuid: this.loan.uuid },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style>
.custom-alert__cancel-btn {
  background-color: #f5f5f5 !important;
  color: #666 !important;
  margin-right: 8px !important;
}

.custom-alert__actions {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.custom-alert__ok-btn,
.custom-alert__cancel-btn {
  flex: 1;
  max-width: 160px;
}
</style>
